angular.module('aprima-core-ui').factory('PanelConfigurationService', ['LocalStorageRepository', '$log', 'widgetViews',
    function (LocalStorageRepository, $log, widgetViews) {

        'use strict';

        var configurations;
        configurations = configurations || LocalStorageRepository.getPatientDashboardConfigurations('all');

        function getWidgetsForLayout() {
            var selectableWidgets = [];
            var widgets = LocalStorageRepository.getPatientDashboardWidgets();
            var view;

            _.forEach(widgets, function (widget) {
                view = _.cloneDeep(_.find(widgetViews, {'id': widget.Id}));
                if (view && view.userPlaceable) {
                    view.Heading = view.displayName;
                    view.Name = view.name;
                    view.TileDescriptorId = view.id;
                    view.Id = view.name + '.template';
                    view.isTemplate = true;
                    view.IsCollapsed = false;
                    selectableWidgets.push(view);
                }
            });

            return selectableWidgets;
        }

        function reloadConfigurations() {
            configurations = LocalStorageRepository.getPatientDashboardConfigurations('all');
        }

        function saveLayout(configName, widgetSetName, widgets){
            var config = _getConfiguration(configName);

            _.forEach(widgets, function(widget){
                if(widget.name && !widget.Name){
                    widget.Name = widget.name;
                }
            });

            config[widgetSetName] = widgets;

            LocalStorageRepository.removePatientDashboardConfigurations('all');
            LocalStorageRepository.setPatientDashboardConfigurations(configurations, 'all');
        }

        function _getConfiguration(configName, dashboards) {
            if(!dashboards){
                dashboards = configurations;
            }
            
            var settings = _.find(dashboards, {Id: configName});

            if (!settings) {
                $log.warn('patient dashboard configuration not found');
            }

            return settings;
        }

        function _getLayout(settings, widgetSetName) {

            var widgets, view, pageViews;
            widgets = settings[widgetSetName];
            pageViews = [];

            _.forEach(widgets, function (widget) {
                view = _.find(widgetViews, {'id': widget.TileDescriptorId});
                if (view && view.userPlaceable) {
                    var clonedWidget = _.cloneDeep(widget);
                    clonedWidget.view = view.view;
                    clonedWidget.configurationView = view.configurationView;
                    clonedWidget.displayName = view.displayName;
                    pageViews.push(clonedWidget);
                }
            });

            return pageViews;
        }

        function _getLayoutWithConfig(config, widgetSetName, dashboards) {
            var settings = _getConfiguration(config, dashboards);
            return _getLayout(settings, widgetSetName);
        }

        return {
            getConfiguration: _getConfiguration,
            getLayout: _getLayout,
            getLayoutWithConfig: _getLayoutWithConfig,
            getWidgetsForLayout: getWidgetsForLayout,
            saveLayout: saveLayout,
            reloadConfigurations: reloadConfigurations,
        };

    }]);